export const GROUP_NAME = 'dialog'

export enum Positions {
  Absolute = 'absolute',
  Fixed = 'fixed',
}

export const DEFAULT_POSITION = Positions.Fixed
